const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const fetchClassesWithWork = async (accessToken) => {
    const classResponse = await fetch('https://classroom.googleapis.com/v1/courses?courseStates=ACTIVE', {
        headers: { Authorization: `Bearer ${accessToken}` }
    });
    const classData = await classResponse.json();

    return await Promise.all(
        (classData.courses || []).map(async (course) => {
            try {
                const workResponse = await fetch(
                    `https://classroom.googleapis.com/v1/courses/${course.id}/courseWork?orderBy=dueDate asc`,
                    { headers: { Authorization: `Bearer ${accessToken}` } }
                );
                const workData = await workResponse.json();

                await delay(100);

                const workWithSubmissions = await Promise.all(
                    (workData.courseWork || []).map(async (work, index) => {
                        try {
                            // Stagger submission requests
                            await delay(index * 50);

                            const submissionResponse = await fetch(
                                `https://classroom.googleapis.com/v1/courses/${course.id}/courseWork/${work.id}/studentSubmissions?userId=me`,
                                { headers: { Authorization: `Bearer ${accessToken}` } }
                            );
                            const submissionData = await submissionResponse.json();
                            return {
                                ...work,
                                submission: submissionData.studentSubmissions?.[0]
                            };
                        } catch (error) {
                            return work;
                        }
                    })
                );

                return { ...course, courseWork: workWithSubmissions };
            } catch (error) {
                console.error(`Error fetching coursework for ${course.name}:`, error);
                return { ...course, courseWork: [] };
            }
        })
    );
};

export const fetchUserInfo = async (accessToken) => {
    const userResponse = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
        headers: { Authorization: `Bearer ${accessToken}` }
    });
    return await userResponse.json();
};
